/* A small, session-only shortlist. Shopify remains the source of prices and stock. */
(() => {
  'use strict';
  const dialog = document.querySelector('[data-compare-dialog]');
  if (!dialog || !dialog.showModal) return;
  const tray = document.querySelector('[data-compare-tray]');
  const status = document.querySelector('[data-compare-status]');
  const key = 'minouko.compare.v1';
  let items = [], opener;
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || '[]');
    if (Array.isArray(saved)) items = saved.filter(p => p && typeof p.id === 'string' && typeof p.title === 'string' && /^\/products\/[a-z0-9-]+$/.test(p.url)).slice(0, 3);
  } catch (_) { /* The comparison also works without storage. */ }
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text != null) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  function sync() {
    document.querySelectorAll('[data-compare-choice]').forEach(label => {
      label.hidden = false;
      const field = label.querySelector('input');
      const found = items.findIndex(p => p.id === field.dataset.id);
      field.checked = found >= 0;
      if (found >= 0) items[found] = { ...field.dataset };
    });
    tray.hidden = !items.length;
    document.body.classList.toggle('has-comparison', !!items.length);
    tray.querySelector('[data-compare-count]').textContent = items.length;
    tray.querySelector('[data-compare-label]').textContent = items.length === 1 ? 'modèle sélectionné' : 'modèles sélectionnés';
    tray.querySelector('[data-compare-open]').disabled = items.length < 2;
    try { sessionStorage.setItem(key, JSON.stringify(items)); } catch (_) { /* Optional storage. */ }
  }
  function render() {
    const table = element('table');
    const caption = element('caption', 'Comparez les modèles sélectionnés');
    caption.className = 'visually-hidden';
    table.append(caption);
    const head = element('thead'), row = element('tr');
    row.append(element('td'));
    items.forEach(p => {
      const cell = element('th'); cell.scope = 'col';
      const image = element('img');
      if (/^https?:\/\//.test(p.image || '') || (p.image || '').startsWith('/')) { image.src = p.image; image.alt = ''; image.width = 180; image.height = 180; cell.append(image); }
      const link = element('a', p.title); link.href = p.url; cell.append(link);
      const remove = element('button', 'Retirer'); remove.type = 'button'; remove.dataset.compareRemove = p.id; remove.setAttribute('aria-label', `Retirer ${p.title} de la comparaison`); cell.append(remove);
      row.append(cell);
    });
    head.append(row); table.append(head);
    const body = element('tbody');
    [['Prix', 'price'], ['Disponibilité', 'available'], ['Matière renseignée', 'material'], ['Options proposées', 'options']].filter(([,field]) => field !== 'material' || items.some(p => p.material)).forEach(([label, field]) => {
      const row = element('tr'), heading = element('th', label); heading.scope = 'row'; row.append(heading);
      items.forEach(p => row.append(element('td', p[field] || (field === 'options' ? 'Un seul modèle' : 'Non précisée'))));
      body.append(row);
    });
    const foot = element('tr'); foot.append(element('td'));
    items.forEach(p => { const cell = element('td'), link = element('a', 'Voir ce modèle', 'compare-model'); link.href = p.url; cell.append(link); foot.append(cell); });
    body.append(foot); table.append(body);
    dialog.querySelector('[data-compare-table]').replaceChildren(table);
  }
  document.addEventListener('change', event => {
    const field = event.target.closest('[data-compare-product]'); if (!field) return;
    if (field.checked) {
      if (items.length >= 3) { field.checked = false; status.textContent = 'Trois modèles sont déjà sélectionnés. Retirez un modèle avant d’en ajouter un autre.'; return; }
      items.push({ ...field.dataset });
    } else items = items.filter(p => p.id !== field.dataset.id);
    status.textContent = `${items.length} modèle${items.length > 1 ? 's' : ''} dans votre comparaison.`; sync();
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-compare-clear]')) { items = []; sync(); status.textContent = 'Comparaison effacée.'; }
    if (event.target.closest('[data-compare-open]') && items.length >= 2) { opener = event.target.closest('button'); render(); dialog.showModal(); dialog.querySelector('[data-compare-close]').focus(); }
    if (event.target.closest('[data-compare-close]')) dialog.close();
    const remove = event.target.closest('[data-compare-remove]');
    if (remove) {
      items = items.filter(p => p.id !== remove.dataset.compareRemove); sync();
      if (items.length < 2) dialog.close(); else { render(); dialog.querySelector('[data-compare-close]').focus(); }
    }
  });
  dialog.addEventListener('close', () => {
    if (opener?.isConnected && !opener.disabled && !tray.hidden) opener.focus();
    else document.querySelector('[data-compare-product]')?.focus();
  });
  document.addEventListener('shopify:section:load', sync);
  sync();
})();
